import React, { useEffect, useState } from "react";
import SideBar from "../master/SideBar";
import NavBar from "../master/NavBar";
import { LoadingDiv } from "../../pages/master/Master";
import { AdminDashboardApi } from "../../api/AdminService";


export default function AdminDashboard() {
    const [loading, setLoading] = useState(false);
    const [summary, setSummary] = useState({});
    const [branches, setBranches] = useState([]);

    const getDashboardData = async () => {
        try {
            setLoading(true);

            const response = await AdminDashboardApi();

            if (response.data.status) {
                setSummary(response.data.data.summary || {});
                setBranches(response.data.data.branch_performance || []);
            }

        } catch (error) {
            console.error("Dashboard Error:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getDashboardData();
    }, []);

    return (
        <>
            {loading && <LoadingDiv />}

            <div className="layout-wrapper layout-content-navbar">
                <div className="layout-container">
                    <SideBar />

                    <div className="layout-page">
                        <NavBar />

                        <div className="content-wrapper">
                            <div className="container-fluid p-4">

                                <div className=" mb-4 ">


                                    <div className="row  g-3">

                                        <div className="col-3">
                                            <div className="simple-card border-primary">
                                                <small className="text-muted fw-bold">
                                                    Total Students
                                                </small>
                                                <h4 className="text-primary m-0">
                                                    {summary?.total}
                                                </h4>
                                            </div>
                                        </div>

                                        <div className="col-3">
                                            <div className="simple-card border-success">
                                                <small className="text-muted fw-bold">
                                                    Active Students
                                                </small>
                                                <h4 className="text-success m-0">
                                                    {summary?.active}
                                                </h4>
                                            </div>
                                        </div>

                                        <div className="col-3">
                                            <div className="simple-card border-info">
                                                <small className="text-muted fw-bold">
                                                    New Admissions Today
                                                </small>
                                                <h4 className="text-info m-0">
                                                    {summary?.new_admissions_today}
                                                </h4>
                                            </div>
                                        </div>

                                        <div className="col-3">
                                            <div className="simple-card border-warning">
                                                <small className="text-muted fw-bold">
                                                    New Admissions Month
                                                </small>
                                                <h4 className="text-warning m-0">
                                                    {summary?.new_admissions_month}
                                                </h4>
                                            </div>
                                        </div>

                                        <div className="col-3">
                                            <div className="simple-card border-danger">
                                                <small className="text-muted fw-bold">
                                                    Active Staff
                                                </small>
                                                <h4 className="text-danger m-0">
                                                    {summary?.active_staff}
                                                </h4>
                                            </div>
                                        </div>

                                        <div className="col-3">
                                            <div className="simple-card border-secondary">
                                                <small className="text-muted fw-bold">
                                                    Total Branches
                                                </small>
                                                <h4 className="text-secondary m-0">
                                                    {summary?.total_branches}
                                                </h4>
                                            </div>
                                        </div>

                                        <div className="col-3">
                                            <div className="simple-card border-success">
                                                <small className="text-muted fw-bold">
                                                    Today Collection
                                                </small>
                                                <h4 className="text-success m-0">
                                                    ₹{summary?.today_collection}
                                                </h4>
                                            </div>
                                        </div>

                                        <div className="col-3">
                                            <div className="simple-card border-primary">
                                                <small className="text-muted fw-bold">
                                                    Month Collection
                                                </small>
                                                <h4 className="text-primary m-0">
                                                    ₹{summary?.month_collection}
                                                </h4>
                                            </div>
                                        </div>



                                    </div>
                                </div>



                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-header py-2">
                                            <h5 className="fw-bold mb-0">
                                                Branch Performance
                                            </h5>
                                        </div>

                                        <div className="table-responsive">
                                            <table className="table align-middle mb-0">
                                                <thead className="table-active">
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Branch</th>
                                                        <th>Batches</th>
                                                        <th>Students</th>
                                                        <th>Admissions (Month)</th>
                                                        <th>Staff</th>
                                                        <th>Collection (Today)</th>
                                                        <th>Collection (Month)</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {branches.length > 0 ? (
                                                        branches?.map((batch, index) => (
                                                            <tr key={index}>
                                                                <td>{index + 1}</td>

                                                                <td className="text-primary">
                                                                    <b>{batch.branch_name}</b>
                                                                </td>

                                                                <td>
                                                                    {batch.total_batches || "-"}
                                                                </td>

                                                                <td className="text-success fw-bold">
                                                                    {batch.total_students}
                                                                </td>

                                                                <td className="text-info fw-bold">
                                                                    {batch.month_admissions}
                                                                </td>

                                                                <td className="text-danger fw-bold">
                                                                    {batch.active_staff}
                                                                </td>


                                                                <td>
                                                                    <span className="badge bg-success">
                                                                        ₹ {Number(batch.today_collection || 0).toLocaleString("en-IN")}
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <span className="badge bg-warning">
                                                                        ₹ {Number(batch.month_collection || 0).toLocaleString("en-IN")}
                                                                    </span>
                                                                </td>

                                                            </tr>

                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="8" className="text-center">
                                                                No Data Found
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}